import { ref } from 'vue';
import { physicalLocationApi, type UpdatePhysicalLocationResponse } from '@/entities/Document';
import { toastError, toastSuccess, useCustomToast } from '@/shared/lib';

import { extractPhysicalLocationNameErrors } from './extractPhysicalLocationNameErrors';

interface UpdatePhysicalLocationResult {
  success: boolean;
  updatedLocation?: UpdatePhysicalLocationResponse['updatedLocation'];
  createdLocations?: UpdatePhysicalLocationResponse['createdLocations'];
  nameErrors?: string[];
}

export function useUpdatePhysicalLocation() {
  const toast = useCustomToast();
  const isUpdating = ref(false);

  async function updatePhysicalLocation(
    id: number,
    names: string[]
  ): Promise<UpdatePhysicalLocationResult> {
    isUpdating.value = true;

    try {
      const response = await physicalLocationApi.updatePhysicalLocation(id, { names });

      toastSuccess(toast, 'Edição salva com sucesso');

      return {
        success: true,
        ...response,
      };
    } catch (error) {
      const nameErrors = extractPhysicalLocationNameErrors(error);

      if (nameErrors) {
        return {
          success: false,
          nameErrors,
        };
      }

      toastError(toast, 'Erro ao editar Local. Tente novamente');

      return {
        success: false,
      };
    } finally {
      isUpdating.value = false;
    }
  }

  return {
    isUpdating,
    updatePhysicalLocation,
  };
}
